<template>
  <div>
    <b-row class="wrapper-projects py-4">
      <b-col v-for="project in projects" :key="project" sm="12" md="6">
        <b-list-group class="w-100 project-list">
          <b-list-group-item class="my-2 p-3  project-card">
            <div class="d-flex justify-content-between align-items-center w-100">
              <b-skeleton width="40%"> </b-skeleton>
              <div class="d-flex gap-2 align-items-center">
                <b-skeleton width="80px"></b-skeleton>
              </div>
            </div>
            <div class="progress-wrap d-flex justify-content-between align-items-center">
              <b-skeleton class="rounded-pill w-100"></b-skeleton>
              <b-skeleton width="20%" class="ml-2"></b-skeleton>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      projects: [1, 2, 3, 4, 5, 6],
    };
  },
};
</script>
